const environment = {
  COMMS_JOURNEY_API_URL: window.portalConfig.url,
  COMMS_JOURNEY_API_KEY: window.portalConfig.apikey,
  ORGANISATION: window.portalConfig.organisation,
  ACCOUNT_TYPE_VALUES: window.portalConfig.accountTypeValues || [],
  AGENT_NOTE: window.portalConfig.agentNote || '',
};
export default environment;
